import React,{useState,useEffect} from 'react';
import { OpenAIApi } from 'openai';
import { Configuration } from 'openai';

import openaiimg from '../assets/img/13.jpeg'

// import SearchBar from './SearchBar';

/*
    The use of dotenv in react apps is more simple than the chaos some of the error
    will arise. One thing I dont have my head wrapped around yet is the difference
    between modules or ?? i cant even think of the alternative, but it's just 
    regular node style javascript using variable definitions at the top of the file 
    rather than the imports used in react framework. 

    the point being the requirement explanation

    just install dotenv in the app like anything else. complete that .env file like any
    other time. put REACT_APP_ in front of every variable that you would have in that file. 
    no not import it or define it or nothing dont go bringing that mother fucker into any 
    file. it will break shit.fuck path . fuck fs. and fuck dotenv. the shit is hidden 

      */


const REACT_APP_OPENAI_KEY =process.env.REACT_APP_OPENAI_KEY

function StoryTeller(){
  const [prompt, setPrompt] = useState("");
 const [result, setResult]= useState("")
 const [isLoading, setIsLoading] = useState(false);

const [isError, setIsError] = useState(false)
const configuration = new Configuration({
  apiKey: REACT_APP_OPENAI_KEY,
  'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10'
})

const openai = new OpenAIApi(configuration);













 useEffect(()=>{
     setPrompt(document.getElementById('userInputField').value)
    //  setResult({})
 },[])



  const generateStory = async() =>{
    setIsLoading(true)
try{
    
    console.log('generateStory was called, and is now in the try block') 


/*
    the await openai.createImage is stored as res so that the data from the request being sent to the api
    can be store in a value. it is stored below BEFORE the catch block so that it can be used to render the
    image in the front end. you can do whatever you want with it, but im going to pull the image from the
    returned OBJECT and have it display on the front end. I am marking this fucking date too, because what
    a win for the dogs. I have been trying and catching for SOMETIME now, and I have been fucking miserable 
    trying to get react framework apis to work for me in the way i want them to and I never really understood
    how try catch blocks were functioning at each step of the function. what a relief. ill do a fireball for this
    1.10.23

            */


   const res =  await openai.createCompletion({
        prompt: "Using the provided story line, setting, plot, etc. Generate a start to a new creative and insteresting book. Include the new title, index page, preface, and introduction. \n Use:" + prompt,


        model: 'text-davinci-003',
        max_tokens:3332,
        temperature:.9

      });
  setResult(res.data);
  console.log("RES.DATA :",res.data.choices[0].text)

  setIsLoading(false)
}catch(error){
setIsLoading(false)
  console.error("FROM 'generateStory', in the catch block, THE ERROR IS RELATED TO: ",error)
}
    console.log('You did it bud, carry on')
  console.log("RESULT :",result)
    }
  

  return (
     <div className="App">


<div className="paypalQrFrame">
</div>
   
      <div className='openai-header'>
        <h2 className='openai-h2'>Start your next book with a unique beginning</h2>
 <img className='banner' src={openaiimg} alt='AI Enthusiast' />
 </div>

        <textarea
          id="userInputField"
          className='ff'
          placeholder="Use some description, plot details, and more to generate your next book."
          onChange={(e) => setPrompt(e.target.value)}
          rows="5"
          cols="100"
        />
        <button className="generate-image-btn btn" onClick={generateStory} >
          
        {isLoading ? (
        <span>
          <i className="fa fa-spinner fa-spin loader" /> Loading
        </span>
      ) : (
        isError ? "Error" : "Open the cover"
      )}
          
          
          </button>

         




<div id="returnedFromAi" className='returnedFromAi'>

{/*  
      The result is from the variable res, which is used to store the api call to openai.
      It is initially empty when the page loads.  Why? we can't get a fucking answer before we ask for it.
      That's why. carry on.
      Add a check on the variable, snoop that mug out a little bit before you go forcing invisible nothingness to 
      the screen or your shits 'broken' will stay broke and youll spend another 34 fucking days before you have done fucking
      messed every aspect of you project up, think you end up finding the solution elsewhere and get back to this point
      again and start that shit all over again and again. just check the damn variable to see if it is even anything, anything at all,
      because if it is, it will be on the front end baby. if not and you checked it, well, here is a bone dog. 

            */}


 {result || result.length > 0 ?  
<div className='result-box'><p className='result-text'> {result.choices[0].text}</p></div>
 : 
 <></>
 
}



<a className='back-link' href="/">back home</a>

<a href="/openai/m1/select" className='back-link'>Try something else</a>



</div>




    </div>

  );
}

export default StoryTeller;
